import { h } from 'preact';
import { SelectEntry } from '../entries/SelectEntry';

const getLoopOptions = (i18n) => [
  { value: 'None', label: i18n.loopNone || 'None' },
  { value: 'Loop', label: i18n.loopStandard || 'Standard Loop' },
  { value: 'SequentialMultiInstance', label: i18n.loopSequentialMI || 'Sequential Multi-Instance' },
  { value: 'ParallelMultiInstance', label: i18n.loopParallelMI || 'Parallel Multi-Instance' },
];

const TASK_TYPES = new Set([
  'epx:UserTask',
  'epx:ServiceTask',
  'epx:ScriptTask',
  'epx:ManualTask',
  'epx:SendTask',
  'epx:ReceiveTask',
  'epx:BusinessRuleTask',
  'epx:CallActivity',
  'epx:SubProcess',
  'epx:Transaction',
]);

export class LoopPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.has(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    return [
      {
        id: 'loopCharacteristics',
        label: i18n.loopCharacteristics || 'Loop / Multi-Instance',
        entries: [
          {
            id: 'loopType',
            component: () => (
              <SelectEntry
                id="epx-loop-type"
                label={i18n.loopType || 'Loop Type'}
                value={props.loopType || 'None'}
                options={getLoopOptions(i18n)}
                onChange={(val) => {
                  lf.setProperties(id, { loopType: val });
                  lf.emit('node:properties-change', { id, properties: { loopType: val } });
                }}
              />
            ),
          },
        ],
      },
    ];
  }
}
